// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ad7bf001","977":"a4d1201c"}[chunkId] + ".chunk.js";
};